// src/config/analyticsApi.js
import axios from './axiosConfig';

const BASE = 'https://hsn.urugowoc.org.rw/backend/api/analytics';

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`
});

export const getAnalyticsSummary = () =>
  axios.get(`${BASE}/visitors`, { params: { period: 'summary' }, headers: authHeaders() })
    .then(r => r.data);

export const getDailyVisitors = (days = 30) =>
  axios.get(`${BASE}/visitors`, { params: { period: 'daily', days }, headers: authHeaders() })
    .then(r => r.data);

export const getMonthlyVisitors = (months = 12) =>
  axios.get(`${BASE}/visitors`, { params: { period: 'monthly', months }, headers: authHeaders() })
    .then(r => r.data);

export const getYearlyVisitors = (years = 5) =>
  axios.get(`${BASE}/visitors`, { params: { period: 'yearly', years }, headers: authHeaders() })
    .then(r => r.data);

export const getRangeVisitors = (from, to) =>
  axios.get(`${BASE}/visitors`, { params: { period: 'range', from, to }, headers: authHeaders() })
    .then(r => r.data);

export const getTopPages = (days = 30) =>
  axios.get(`${BASE}/visitors`, { params: { period: 'top-pages', days }, headers: authHeaders() })
    .then(r => r.data);

export const getDeviceBreakdown = (days = 30) =>
  axios.get(`${BASE}/visitors`, { params: { period: 'devices', days }, headers: authHeaders() })
    .then(r => r.data);

export const getRecentVisits = (page = 1, limit = 50) =>
  axios.get(`${BASE}/visitors`, { params: { period: 'recent', page, limit }, headers: authHeaders() })
    .then(r => r.data);

export const pingActiveSession = (sessionId) =>
  axios.post('https://hsn.urugowoc.org.rw/backend/api/analytics-ping',
    { session_id: sessionId },
    { headers: authHeaders() }
  ).then(r => r.data);